export default "__VITE_ASSET__CtXfEO91__"